// src/admin/components/TierBadge.tsx
import type { Database } from '@/lib/database.types';
import styles from './TierBadge.module.css';

type Tier = Database['public']['Enums']['credit_tier'];
const LABEL: Record<Tier, string> = {
  new: 'New', building: 'Building', established: 'Established', strong: 'Strong', excellent: 'Excellent',
};
export default function TierBadge({ tier }: { tier: Tier }) {
  return <span className={`${styles.badge} ${styles[tier]}`}>{LABEL[tier]}</span>;
}
